<template>
  <div>
    <v-stepper v-model="e6" vertical class="shadow-xl mx-5 my-5 pa-5">
      <router-link to="/alerts">
        <v-btn depressed color="primary" class="mb-5"> <v-icon>arrow_back</v-icon>Go back </v-btn>
      </router-link>
      <h3 class="title">Add alert</h3>
      <v-stepper-step :complete="e6 > 1" step="1" editable>Alert Name</v-stepper-step>
      <v-stepper-content step="1">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-text-field label="Alert Name" maxlength="30" counter v-model="Name" outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-btn color="primary" depressed class="mr-3 my-3" @click="e6 = 2">Continue</v-btn>
      </v-stepper-content>
      <v-stepper-step :complete="e6 > 2" step="2" editable>Alert for</v-stepper-step>
      <v-stepper-content step="2">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              dense
              v-model="NotificationType"
              :items="Types"
              item-text="label"
              item-value="value"
              label="Select Type"
              outlined
            />
          </v-col>
        </v-row>
        <v-row v-if="NotificationType === notificationTypes.TASK">
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              dense
              v-model="ScriptIds"
              :items="scripts"
              item-text="Name"
              item-value="Id"
              label="Select Scripts"
              multiple
              chips
              small-chips
              deletable-chips
              outlined
              class="cf-alert-script-select"
              hint="Birden fazla script seçebilirsiniz; her biri için aynı agent ve durum kuralları geçerli olur."
              persistent-hint
            />
            <v-autocomplete dense v-model="AgentIds" :items="agents" item-text="Name" item-value="Id" label="Select Agents" multiple outlined></v-autocomplete>
            <v-autocomplete
              dense
              v-model="NotifyOn"
              :items="jobStatuses"
              item-text="label"
              item-value="value"
              label="Select Job Status"
              outlined
            />
          </v-col>
        </v-row>
        <v-row v-if="NotificationType === notificationTypes.WORKFLOW">
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              dense
              v-model="WorkflowIds"
              :items="workflows"
              item-text="name"
              item-value="id"
              label="Select Workflows"
              multiple
              chips
              small-chips
              deletable-chips
              outlined
              :loading="workflowsLoading"
              class="cf-alert-script-select"
              hint="Birden fazla workflow seçebilirsiniz."
              persistent-hint
            />
            <v-autocomplete
              dense
              v-model="NotifyOn"
              :items="workflowStatuses"
              item-text="label"
              item-value="value"
              label="Execution status"
              outlined
              class="mt-3"
            />
            <p class="text-caption text--secondary mt-2 mb-0">
              Çalıştırma bitince Telegram/e-posta vb. kanallara <strong>süreç adı</strong> ve
              <strong>başarı veya hata</strong> durumu otomatik yazılır. Yukarıdaki “Execution status” ile hangi
              sonuçlarda bildirim gideceğini seçin (tümü / sadece hata / sadece başarı).
              Workflow ayarlarındaki <strong>error workflow</strong> bundan bağımsızdır.
            </p>
          </v-col>
        </v-row>
        <v-row v-if="NotificationType === notificationTypes.AGENT">
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete dense v-model="AgentIds" :items="agents" item-text="Name" item-value="Id" label="Select Agents" multiple outlined></v-autocomplete>
            <p class="text-caption text--secondary mt-1 mb-0">
              Agent bağlanınca / kopunca bildirim için <strong>Alert for → Agent</strong> seçin. Jobs tablosundaki “Disconnected” iş kaydıdır; Task alert bunu tetiklemez.
            </p>
          </v-col>
        </v-row>
        <v-btn color="primary" depressed class="mr-3 my-3" @click="e6 = 3">Continue</v-btn>
      </v-stepper-content>
      <v-stepper-step :complete="e6 > 3" step="3" editable>Alert to</v-stepper-step>
      <v-stepper-content step="3" class="my-0 py-0 mx-0 my-0">
        <TaskMailDialog v-model="EmailList" />
        <TaskSlackDialog v-model="SlackWebHookUrl" />
        <TaskSlackDialog v-model="MicrosoftTeamsWebHookUrl" buttonName="Microsoft Teams" />
        <TaskSlackDialog v-model="GoogleChatWebHookUrl" buttonName="Google Chat" />
        <TaskSlackDialog v-model="HypeWebHookUrl" buttonName="Hype" />
        <TaskSlackDialog v-model="WebHookUrl" buttonName="Webhook" />
        <TaskChatflowDialog v-model="chatflowAlert" :message-hint="chatflowMessageHint" />

        <v-card flat outlined class="my-1" v-show="chatflowConfigured">
          <v-card-text class="pb-1">
            <div>Chatflow Alert</div>
            <div class="text--primary">
              {{ chatflowSummary }}
              <v-btn @click="testChatflow()" small depressed>
                <v-icon left>play_arrow</v-icon>Test Now
              </v-btn>
            </div>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn @click="clearChatflow()" text small class="pl-2" color="red white--text" depressed>
              <v-icon small>delete_outline</v-icon>Delete
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card flat outlined class="my-1" v-show="!!EmailList">
          <v-card-text class="pb-1">
            <div>E-Mail Alert</div>
            <div class="text--primary">
              Send an e-mail to {{ EmailList }}
              <v-btn @click="testMail()" small depressed> <v-icon left>play_arrow</v-icon>Test Now </v-btn>
            </div>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn @click="EmailList = ''" text small class="pl-2" color="red white--text" depressed> <v-icon small>delete_outline</v-icon>Delete </v-btn>
          </v-card-actions>
        </v-card>
        <v-card flat outlined class="my-1" v-show="!!SlackWebHookUrl">
          <v-card-text class="pb-1">
            <div>Slack Alert</div>
            <div class="text--primary">
              Send an slack message to
              <a :href="SlackWebHookUrl">WebhookURL</a>
              <v-btn @click="testWebHook(SlackWebHookUrl)" small depressed> <v-icon left>play_arrow</v-icon>Test Now </v-btn>
            </div>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn @click="SlackWebHookUrl = ''" text small class="pl-2" color="red white--text" depressed> <v-icon small>delete_outline</v-icon>Delete </v-btn>
          </v-card-actions>
        </v-card>
        <v-card flat outlined class="my-1" v-show="!!MicrosoftTeamsWebHookUrl">
          <v-card-text class="pb-1">
            <div>Microsoft Teams Alert</div>
            <div class="text--primary">
              Send an message to
              <a :href="MicrosoftTeamsWebHookUrl">Microsoft Teams WebhookURL</a>
              <v-btn @click="testWebHook(MicrosoftTeamsWebHookUrl)" small depressed> <v-icon left>play_arrow</v-icon>Test Now </v-btn>
            </div>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn @click="MicrosoftTeamsWebHookUrl = ''" text small class="pl-2" color="red white--text" depressed>
              <v-icon small>delete_outline</v-icon>Delete
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card flat outlined class="my-1" v-show="!!GoogleChatWebHookUrl">
          <v-card-text class="pb-1">
            <div>Google Chat Alert</div>
            <div class="text--primary">
              Send an message to
              <a :href="GoogleChatWebHookUrl">Google Chat WebhookURL</a>
              <v-btn @click="testWebHook(GoogleChatWebHookUrl)" small depressed> <v-icon left>play_arrow</v-icon>Test Now </v-btn>
            </div>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn @click="GoogleChatWebHookUrl = ''" text small class="pl-2" color="red white--text" depressed> <v-icon small>delete_outline</v-icon>Delete </v-btn>
          </v-card-actions>
        </v-card>
        <v-card flat outlined class="my-1" v-show="!!HypeWebHookUrl">
          <v-card-text class="pb-1">
            <div>Hype Alert</div>
            <div class="text--primary">
              Send an message to
              <a :href="HypeWebHookUrl">Hype WebhookURL</a>
              <v-btn @click="testWebHook(HypeWebHookUrl)" small depressed> <v-icon left>play_arrow</v-icon>Test Now </v-btn>
            </div>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn @click="HypeWebHookUrl = ''" text small class="pl-2" color="red white--text" depressed> <v-icon small>delete_outline</v-icon>Delete </v-btn>
          </v-card-actions>
        </v-card>
        <v-card flat outlined class="my-1" v-show="!!WebHookUrl">
          <v-card-text class="pb-1">
            <div>Hype Alert</div>
            <div class="text--primary">
              Send an message to
              <a :href="WebHookUrl">WebhookURL</a>
              <v-btn @click="testWebHook(WebHookUrl)" small depressed> <v-icon left>play_arrow</v-icon>Test Now </v-btn>
            </div>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn @click="WebHookUrl = ''" text small class="pl-2" color="red white--text" depressed> <v-icon small>delete_outline</v-icon>Delete </v-btn>
          </v-card-actions>
        </v-card>
        <br />
        <v-btn class="my-5 mx-1" @click="save" v-show="canSaveAlert" depressed color="primary">SAVE ALERT</v-btn>
        <router-link to="/alerts" style="text-decoration:none;">
          <v-btn class="my-5 mx-1" depressed>CANCEL</v-btn>
        </router-link>
      </v-stepper-content>
      <ConfirmDialog />
    </v-stepper>
  </div>
</template>

<script>
import TaskMailDialog from "./TaskMailDialog";
import TaskSlackDialog from "./TaskSlackDialog";
import TaskChatflowDialog from "./TaskChatflowDialog";
import ConfirmDialog from "../ConfirmDialog";
import { mapState, mapActions } from "vuex";
import { FETCH_SCRIPTS } from "../../store/modules/script";
import { FETCH_AGENTS } from "../../store/modules/agent";
import { OPEN_DIALOG } from "../../store/modules/confirm";
import {
  NotificationTypes,
  NotificationNotifyOnStatuses,
  WorkflowNotifyOnStatuses,
} from "../../store/modules/alert";
import Api from "../../api";
import HypeApi from "../../hype/api";
import ChatflowApi from "../../chatflow/api";
import {
  encodeChatflowAlertPayload,
  decodeChatflowAlertPayload,
  isChatflowWebhookSlot,
} from "../../utils/chatflowAlertStorage";

export default {
  components: { TaskMailDialog, TaskSlackDialog, TaskChatflowDialog, ConfirmDialog },
  computed: {
    ...mapState("script", {
      scripts: (state) => state.scripts,
    }),
    ...mapState("agent", {
      agents: (state) => state.agents,
    }),
    chatflowConfigured() {
      return !!(this.chatflowAlert && this.chatflowAlert.channelId && this.chatflowAlert.contactIds?.length);
    },
    chatflowSummary() {
      if (!this.chatflowConfigured) return "";
      const n = this.chatflowAlert.contactIds.length;
      const ch = this.chatflowChannelLabel || "Kanal";
      return `${ch} → ${n} alıcı`;
    },
    canSaveAlert() {
      return (
        !!this.EmailList ||
        !!this.SlackWebHookUrl ||
        !!this.GoogleChatWebHookUrl ||
        !!this.MicrosoftTeamsWebHookUrl ||
        !!this.HypeWebHookUrl ||
        !!this.WebHookUrl ||
        this.chatflowConfigured
      );
    },
    chatflowMessageHint() {
      if (this.NotificationType === this.notificationTypes.WORKFLOW) {
        return "Workflow: boş bırakın — süreç adı, başarı/hata durumu ve çalıştırma linki otomatik gider. İsterseniz ek not yazın.";
      }
      if (this.NotificationType === this.notificationTypes.AGENT) {
        return "Agent: boş bırakın — bağlandı/koptu metni otomatik gider.";
      }
      return "Task: boş bırakın — script adı, agent, durum ve iş linki otomatik gider. İsterseniz ek not yazın.";
    },
    scriptPreviewName() {
      if (!this.ScriptIds?.length || !this.scripts?.length) return "Örnek script";
      const id = this.ScriptIds[0];
      const s = this.scripts.find((x) => x.Id === id);
      return (s && s.Name) || "Script";
    },
    agentPreviewName() {
      if (!this.AgentIds?.length || !this.agents?.length) return "Örnek agent";
      const id = this.AgentIds[0];
      const a = this.agents.find((x) => x.Id === id);
      return (a && a.Name) || "Agent";
    },
    workflowPreviewName() {
      if (!this.WorkflowIds?.length || !this.workflows?.length) return "Örnek süreç";
      const id = String(this.WorkflowIds[0]);
      const wf = this.workflows.find((w) => String(w.id) === id);
      return (wf && wf.name) || `Workflow #${id}`;
    },
  },
  methods: {
    ...mapActions("script", {
      fetchScripts: FETCH_SCRIPTS,
    }),
    ...mapActions("agent", {
      fetchAgents: FETCH_AGENTS,
    }),
    ...mapActions("confirm", {
      confirm: OPEN_DIALOG,
    }),
    async testMail() {
      await Api.sendTestMail(this.EmailList);
      this.confirm({
        message: "A test mail has been sent.",
        title: "information",
        showCancelButton: false,
      });
    },
    async testWebHook(url) {
      await Api.sendTestWebHookMessage(url);
      this.confirm({
        message: "A test message has been sent.",
        title: "information",
        showCancelButton: false,
      });
    },
    clearChatflow() {
      this.chatflowAlert = null;
      this.chatflowChannelLabel = "";
    },
    async resolveChatflowChannelLabel(channelId) {
      try {
        const channels = await ChatflowApi.getChannels();
        const ch = (channels || []).find((c) => c.id === channelId);
        if (!ch) return "Kanal";
        return `${ch.name || "Kanal"} (${ch.type}${ch.credentials?.botUsername ? ` @${ch.credentials.botUsername}` : ""})`;
      } catch (e) {
        return "Kanal";
      }
    },
    buildWorkflowTestMessage(success = true) {
      const title = success ? "✅ Workflow tamamlandı" : "❌ Workflow hatası";
      const statusLine = success
        ? "Durum: Süreç başarıyla tamamlandı."
        : "Durum: Süreç hata ile sonlandı.";
      const lines = [
        title,
        "",
        `Süreç: ${this.workflowPreviewName}`,
        `Uyarı: ${this.Name || "Alert"}`,
        statusLine,
      ];
      if (!success) lines.push("Hata özeti: (örnek) Test hata mesajı");
      const note = (this.chatflowAlert?.message || "").trim();
      if (note) lines.push("", `Not: ${note}`);
      lines.push("", "Çalıştırma kaydı: (canlı çalışmada link gelir)");
      return lines.join("\n");
    },
    buildTaskTestMessage(success = true) {
      const title = success ? "✅ Script tamamlandı" : "❌ Script hatası";
      const statusLine = success
        ? "Durum: Script başarıyla tamamlandı."
        : "Durum: Script hata ile sonlandı.";
      const lines = [
        title,
        "",
        `Script: ${this.scriptPreviewName}`,
        `Agent: ${this.agentPreviewName}`,
        `Uyarı: ${this.Name || "Alert"}`,
        statusLine,
      ];
      if (!success) lines.push("Hata özeti: Çıkış kodu 1");
      const note = (this.chatflowAlert?.message || "").trim();
      if (note) lines.push("", `Not: ${note}`);
      lines.push("", "İş kaydı: (canlı çalışmada link gelir)");
      return lines.join("\n");
    },
    async testChatflow() {
      const cf = this.chatflowAlert;
      let text = (cf.message || "").trim();
      if (this.NotificationType === this.notificationTypes.WORKFLOW) {
        text = this.buildWorkflowTestMessage(true);
      } else if (this.NotificationType === this.notificationTypes.TASK) {
        text = this.buildTaskTestMessage(true);
      } else if (!text) {
        text = `[Test] ${this.Name || "Alert"} — Robbot uyarı testi`;
      }
      const result = await ChatflowApi.deliverAlert({
        channelId: cf.channelId,
        contactIds: cf.contactIds,
        text,
      });
      const sent = result?.sent ?? 0;
      const total = result?.total ?? cf.contactIds.length;
      this.confirm({
        message: `${sent}/${total} alıcıya Telegram mesajı gönderildi.`,
        title: sent > 0 ? "Success" : "information",
        showCancelButton: false,
      });
    },
    alertBody() {
      const scriptIds = Array.isArray(this.ScriptIds) ? [...this.ScriptIds] : [];
      const workflowIds = Array.isArray(this.WorkflowIds) ? [...this.WorkflowIds] : [];
      const body = {
        Name: this.Name,
        ScriptIds: this.NotificationType === this.notificationTypes.TASK ? scriptIds : [],
        ScriptId: scriptIds[0] || "",
        WorkflowIds:
          this.NotificationType === this.notificationTypes.WORKFLOW
            ? workflowIds.map(String)
            : [],
        AgentIds: this.AgentIds,
        NotificationType: this.NotificationType,
        NotifyOn: this.NotifyOn,
        EmailList: this.EmailList,
        SlackWebHookUrl: this.SlackWebHookUrl,
        MicrosoftTeamsWebHookUrl: this.MicrosoftTeamsWebHookUrl,
        GoogleChatWebHookUrl: this.GoogleChatWebHookUrl,
        HypeWebHookUrl: this.HypeWebHookUrl,
        WebHookUrl: this.WebHookUrl,
        SlackName: "",
      };
      if (this.chatflowConfigured) {
        body.ChatflowChannelId = this.chatflowAlert.channelId;
        body.ChatflowContactIds = this.chatflowAlert.contactIds;
        body.ChatflowMessage = this.chatflowAlert.message || "";
      }
      return body;
    },
    apiErrorMessage(e) {
      const d = e.response && e.response.data;
      return (d && (d.reason || d.message || d.Message)) || e.message;
    },
    async persistAlert(saveFn) {
      try {
        await saveFn(this.alertBody());
        return { ok: true };
      } catch (e) {
        const status = e.response && e.response.status;
        const msg = this.apiErrorMessage(e);
        if (status === 422 && this.chatflowConfigured) {
          const fallback = this.alertBody();
          delete fallback.ChatflowChannelId;
          delete fallback.ChatflowContactIds;
          delete fallback.ChatflowMessage;
          if (this.WebHookUrl && !isChatflowWebhookSlot(this.WebHookUrl)) {
            await this.confirm({
              message: `Chatflow kaydedilemedi (${msg}). Ayrıca gerçek bir Webhook URL tanımlı; ikisini birlikte kullanamazsınız.`,
              title: "Error",
              showCancelButton: false,
            });
            return { ok: false };
          }
          fallback.WebHookUrl = encodeChatflowAlertPayload(this.chatflowAlert);
          await saveFn(fallback);
          this.WebHookUrl = fallback.WebHookUrl;
          return { ok: true, chatflowLegacyStore: true };
        }
        await this.confirm({
          message: msg || "Alert kaydedilemedi.",
          title: "Error",
          showCancelButton: false,
        });
        return { ok: false };
      }
    },
    async save() {
      this.validation();

      if (this.Id) {
        this.update();
      } else {
        this.create();
      }
    },
    validation() {
      if (this.NotificationType === NotificationTypes.AGENT) {
        this.ScriptIds = [];
        this.ScriptId = "";
        this.WorkflowIds = [];
        this.NotifyOn = 0;
      } else if (this.NotificationType === NotificationTypes.WORKFLOW) {
        this.ScriptIds = [];
        this.ScriptId = "";
        this.AgentIds = [];
      } else if (this.NotificationType === NotificationTypes.TASK) {
        this.WorkflowIds = [];
      }
    },
    async loadWorkflows() {
      this.workflowsLoading = true;
      try {
        this.workflows = (await HypeApi.getWorkflows()) || [];
      } catch (e) {
        console.error(e);
        this.workflows = [];
      } finally {
        this.workflowsLoading = false;
      }
    },
    async create() {
      const result = await this.persistAlert((body) => Api.createAlert(body));
      if (!result.ok) return;
      const extra = result.chatflowLegacyStore
        ? " Chatflow ayarı kaydedildi (eski main — güncel main deploy edilince doğrudan kolonlara geçer)."
        : "";
      await this.confirm({
        message: `Alert has successfully created!${extra}`,
        title: "Success",
        okButtonTitle: "OK",
        showCancelButton: false,
      });
      this.$router.push("/alerts");
    },
    async update() {
      const result = await this.persistAlert((body) => Api.updateAlert(this.Id, body));
      if (!result.ok) return;
      const extra = result.chatflowLegacyStore
        ? " Chatflow ayarı kaydedildi (eski main — güncel main deploy edilince doğrudan kolonlara geçer)."
        : "";
      await this.confirm({
        message: `Alert has successfully updated!${extra}`,
        title: "Success",
        okButtonTitle: "OK",
        showCancelButton: false,
      });
      this.$router.push("/alerts");
    },
  },
  watch: {
    async chatflowAlert(v) {
      if (v && v.channelId) {
        this.chatflowChannelLabel = await this.resolveChatflowChannelLabel(v.channelId);
      } else {
        this.chatflowChannelLabel = "";
      }
    },
    e6(val) {
      switch (val) {
        case 2:
          if (!this.Name) {
            this.e6 = 1;
          }
          break;
        case 3:
          if (this.NotificationType === 0) this.e6 = 2;
          else if (this.NotificationType === NotificationTypes.TASK && (!this.ScriptIds || !this.ScriptIds.length))
            this.e6 = 2;
          else if (
            this.NotificationType === NotificationTypes.WORKFLOW &&
            (!this.WorkflowIds || !this.WorkflowIds.length)
          )
            this.e6 = 2;
          break;
      }
    },
    NotificationType(val) {
      if (val === NotificationTypes.AGENT) {
        this.ScriptIds = [];
        this.ScriptId = "";
        this.WorkflowIds = [];
        this.NotifyOn = 0;
      } else if (val === NotificationTypes.WORKFLOW) {
        this.ScriptIds = [];
        this.ScriptId = "";
        this.AgentIds = [];
        if (!this.WorkflowIds.length) this.loadWorkflows();
      } else if (val === NotificationTypes.TASK) {
        this.WorkflowIds = [];
      }
    },
  },
  data: () => ({
    e6: 1,
    Id: "",
    Name: "",
    NotificationType: 0,
    Types: [
      { label: "Agent", value: NotificationTypes.AGENT },
      { label: "Task", value: NotificationTypes.TASK },
      { label: "Workflow", value: NotificationTypes.WORKFLOW },
    ],
    notificationTypes: NotificationTypes,
    ScriptId: "",
    ScriptIds: [],
    WorkflowIds: [],
    workflows: [],
    workflowsLoading: false,
    AgentIds: [],
    NotifyOn: 0,
    EmailList: "",
    SlackWebHookUrl: "",
    MicrosoftTeamsWebHookUrl: "",
    GoogleChatWebHookUrl: "",
    HypeWebHookUrl: "",
    WebHookUrl: "",
    chatflowAlert: null,
    chatflowChannelLabel: "",
    jobStatuses: [
      { label: "All statuses", value: NotificationNotifyOnStatuses.ALL_JOB_STATUS },
      { label: "Job failed", value: NotificationNotifyOnStatuses.JOB_FAIL },
      { label: "Job success", value: NotificationNotifyOnStatuses.JOB_SUCCESS },
    ],
    workflowStatuses: [
      { label: "All (success and failure)", value: WorkflowNotifyOnStatuses.ALL },
      { label: "Execution failed", value: WorkflowNotifyOnStatuses.EXECUTION_FAIL },
      { label: "Execution success", value: WorkflowNotifyOnStatuses.EXECUTION_SUCCESS },
    ],
    userPlan: {},
  }),
  async beforeCreate() {
    this.userPlan = await Api.getUserPlan();
  },
  async created() {
    await this.fetchScripts();
    await this.fetchAgents();

    let id = this.$route.params.id;
    if (id) {
      Api.getAlert(id).then(async (alert) => {
        Object.assign(this, alert);
        this.AgentIds = alert.Agents.map((agent) => agent.Id);
        if (Array.isArray(alert.ScriptIds) && alert.ScriptIds.length) {
          this.ScriptIds = [...alert.ScriptIds];
        } else if (alert.ScriptId) {
          this.ScriptIds = [alert.ScriptId];
        } else {
          this.ScriptIds = [];
        }
        this.ScriptId = this.ScriptIds[0] || "";
        if (Array.isArray(alert.WorkflowIds) && alert.WorkflowIds.length) {
          this.WorkflowIds = [...alert.WorkflowIds];
        } else {
          this.WorkflowIds = [];
        }
        if (alert.NotificationType === NotificationTypes.WORKFLOW) {
          await this.loadWorkflows();
        }
        let cf = null;
        if (alert.ChatflowChannelId && alert.ChatflowContactIds?.length) {
          cf = {
            channelId: alert.ChatflowChannelId,
            contactIds: alert.ChatflowContactIds,
            message: alert.ChatflowMessage || "",
          };
        } else {
          cf = decodeChatflowAlertPayload(alert.WebHookUrl);
          if (cf && isChatflowWebhookSlot(alert.WebHookUrl)) {
            this.WebHookUrl = "";
          }
        }
        if (cf) {
          this.chatflowAlert = cf;
          this.chatflowChannelLabel = await this.resolveChatflowChannelLabel(cf.channelId);
        }
      });
    }
  },
};
</script>

<style>
.shadow-xl {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.cf-alert-script-select .v-menu__content {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.cf-alert-script-select .v-menu__content::-webkit-scrollbar {
  display: none;
}
</style>
